import axios from 'axios';

// 微信分享
function share(options) {
  var api = "//h5api.zuimeitianqi.com/h5DataServer/";
  var pageId = options.pageId || "",
      spaceIdH50 = "H50", // 好友
      spaceIdH51 = "H51"; // 朋友圈
  var obj = new Object();
  obj.title = options.title || "分享标题";
  obj.desc = options.desc || "分享描述";
  obj.thumb = options.thumb || "";
  obj.link = options.link || "";
  obj.locationSuccess = options.locationSuccess || "";
  console.log('执行share函数');
  // https://h5api.zuimeitianqi.com/h5DataServer/getHistoryWeatherData?citycode=01012507&month=2023-07&apikey=05a20e82b0137c9ebc224661a4dcbe6a
  // $.ajax({
  //   type: 'get',
  //   url: api + "getJsApiTicket?url=" + encodeURIComponent(location.href.split('#')[0]),
  //   success: function (data) {
  //     console.log('share请求成功 :>> %O', data);
  //     obj.wxShare(data);
  //   },
  //   error: function(xhr, status, error) {
  //     // 请求失败时的回调函数
  //     console.log('share请求失败:', status, error);
  //   }
  // });
  axios({
    methods: 'GET',
    url: api + "getJsApiTicket?url=" + encodeURIComponent(location.href.split('#')[0])
  }).then((res) => {
    console.log('share请求成功 :>> %O', res);
    if (res.status == 200) {
      obj.wxShare(res.data);
    }
  }).catch((err) => {
    console.log('share请求失败:', err);
  });

  obj.wxShare = function (conf) {
    console.log('执行wxShare config');
    wx.config({
      debug: false,
      appId: conf.appId,
      timestamp: conf.timestamp,
      nonceStr: conf.nonceStr,
      signature: conf.signature,
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
    });
    wx.ready(function () {
      console.log('wx.ready: %O');

      wx.updateAppMessageShareData({        // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
        title: obj.title,
        desc: obj.desc,
        link: obj.link,
        imgUrl: obj.thumb,
        success: function () {
          console.log('updateAppMessageShareData :>> ');
        }
      });
      wx.updateTimelineShareData({     // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
        title: obj.desc,
        link: obj.link,
        imgUrl: obj.thumb,
        success: function () {
          console.log('updateTimelineShareData :>> ');
        }
      });
    })
    wx.error(function (res) {
      console.log('wx.error: %O', res);
    });
  }
}

const utils = {
  cityId: '',
  // 将赤道坐标系转换为直角坐标系
  // 赤经：度；以小时为单位从0h~24h，每15°为1h，总计360。
  // 赤纬：度；范围为+90°~-90°。
  // 距离，单位是任意长度单位（比如光年）。
  convertEquatorialToXYZ: function(alpha, delta, distance) {
    // 赤经、赤纬
    const alphaRad = (alpha * Math.PI) / 180;
    const deltaRad = (delta * Math.PI) / 180;

    // 将距离转换为千米
    const distanceKm = (distance / 149597870.7) * (149597870.7 / 1000);

    // 将赤道坐标系转换为直角坐标系
    const x = distanceKm * Math.cos(alphaRad) * Math.cos(deltaRad);
    const y = distanceKm * Math.sin(alphaRad) * Math.cos(deltaRad);
    const z = distanceKm * Math.sin(deltaRad);

    const xTimes = 1;
    const yTimes = 1;
    const zTimes = 1;
    return {
      x: x * xTimes,
      y: y * yTimes,
      z: z * zTimes
    };
  },
  // 是否在天气App的webview中
  isWeaWebview: function() {
    let inWeaWebview = false;
    if (window.JSInterface && window.JSInterface.goBack) {
      inWeaWebview = true;
    }
    // console.error('inWeaWebview :>> ', inWeaWebview);
    return inWeaWebview;
  },
  // 是否在天气App的webview中全屏打开
  isWeaWvFullScreen: function() {
    const isWeaWebview = utils.isWeaWebview();
    let fullScreen = false;
    if (isWeaWebview) {
      // const href = window.location.href;
      // if (href.includes('fullScreen=true')) {
      //   fullScreen = true;
      // }
      fullScreen = true;
    }
    // fullScreen = true;
    console.error('fullScreen :>> ', fullScreen);
    return fullScreen;
  },
  jsbGetStatusHeight: function() {
    let statusHeight = 0;
    if (utils.isWeaWvFullScreen() && window.JSInterface && window.JSInterface.getStatusHeight) {
      statusHeight = JSON.parse(window.JSInterface.getStatusHeight()).dp;
    }
    return statusHeight;
  },
  jsbClientShare: function() {
    const clientShare = window.JSInterface && window.JSInterface.clientShare;
    if (clientShare) {
      window.JSInterface.clientShare();
    } else {
      console.error('no clientShare');
    }
  },
  jsbGetShareResources: function(params) {
    const getShareResources = window.JSInterface && window.JSInterface.getShareResources;
    if (getShareResources) {
      // "pictureUrl": "XXX", //分享大图
      // "shareTitle": "XXX", // 分享标题
      // "shareUrl": "XXX", // 分享链接
      // "shareDescription": "XXX" // 分享描述
      window.JSInterface.getShareResources(params);
    } else {
      console.error('no getShareResources');
    }
  },
  getUrlSearch: function() {
    var hash = window.location.hash;
    var search = hash.slice(hash.indexOf('?'));
    if (utils.cityId) {
      var cityId = "cityId=" + utils.getCityId() + "&";
      search = search.replace(/cityId.*?&/, cityId);
    }
    return search;
  },
  checkExists: function(strObj, searchValue) {
    return strObj.indexOf(searchValue) >= 0 ? true : false;
  },
  replaceQueryString: function (options) {
    var option = options || {},
        key = option.key || '',
        value = option.value || '',
        search = option.search || utils.getUrlSearch(),
        pattern = key + '=([^&]*)',
        replaceText = key + '=' + value;
    if (!utils.checkExists(search, 'source=zm')) {
        search = search + "&source=zm"
    }
    return search.match(pattern) ?
      search.replace(eval('/(' + key + '=)([^&]*)/g'), replaceText) : (search.match('[\?]') ? search + '&' + replaceText : search + '?' + replaceText);
  },
  getParamsFromUrl: function(url) {
    var Request = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(1), // 去掉?号
            strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            Request[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
    }
    return Request;
  },
  getQueryString: function(name) { // url 请求参数
    if (name) {
      var obj = utils.getParamsFromUrl(window.location.search);
      return obj[name];
    }
    return "";
  },
  getCityId: function() { // 获取cityId
    return utils.cityId || utils.getQueryString("cityId") || "01010101";
  },
  isWeiXin: function() {
    return /MicroMessenger/i.test(navigator.userAgent) ? true : false;
  },
  isEmpty: function (str) {
    if (str == undefined || str === '' || str == null || str.length == 0) {
        return true;
    }
    return false;
  },
  // 加载js脚本
  loadScript(options) {
    var options = options || {},
      src = options.src || "",
      id = options.id || "",
      success = options.success || "",
      error = options.error || "";

    if (!utils.isEmpty(id) && !utils.isEmpty(document.getElementById(id))) {
      success && success();
      return;
    }
    if (!utils.isEmpty(error)) {
      error && error();
      return;
    }

    var _doc = document.getElementsByTagName("head")[0];
    var script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", src);
    if (!utils.isEmpty(id)) {
      script.setAttribute("id", id);
    }
    _doc.appendChild(script);
    if (document.all) {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        success && success();
      }
    } else {
      script.onload = function() {
        success && success();
      };
    }
  },
  // 加载微信SDK
  loadWxSdk(callback) {
    var loadNum = 2;
    console.log('执行loadWxSdk');
    utils.loadScript({
      src: "//res2.wx.qq.com/open/js/jweixin-1.6.0.js",
      success: function() {
        loadNum--;
        // if (loadNum == 0) {
        //   callback();
        // }
        callback();
        console.log('loadWxSdk成功1 :>> ');
      },
      error: function() {
        console.log('loadWxSdk失败 :>> ');
      }
    });
  },
  WeiXinShare: function(options) {
    var options = options || {},
        title = options.title || "",
        desc = options.desc || "",
        thumb = options.thumb || "img_wx_default.png",
        href = location.href,
        cityId = "cityId=" + utils.getCityId() + "&",
        shareUrl = href.replace(/cityId.*?&/, cityId), //去切换后分享链接替换
        link = options.link || shareUrl,
        pageId = options.pageId || "";
    if (utils.isWeiXin()) {
      utils.loadWxSdk(function() {
          // if (!utils.checkExists(thumb, "dl.zuimeitianqi.com")) {
          //   thumb = location.protocol + cdnStatic.replace("s4", "h5") + "/res/img/weixin_new/" + thumb;
          // }
          console.log('loadWxSdk成功');
          // 请求微信
          new share({
            title: title,
            desc: desc,
            thumb: thumb,
            link: link,
            pageId: pageId
          });
      })
    }
  }
};

export default utils;
